// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("local-time").start()
require("select2")
require("moment")
require("daterangepicker")
require("chartkick")
require("chart.js")

window.Rails = Rails

import 'bootstrap'
import 'data-confirm-modal'

$(document).on("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  
  $('.select2').select2({
  	theme: 'bootstrap4',
  })

  $('.dates').daterangepicker({
  	locale: {
      format: 'DD/MM/YYYY'
    },
     "maxSpan": {
        "days": 31
    },
  });
})
